<script>
  import VueCookies from 'vue-cookies';
  import { emitter } from '@/main.js';
  import { debounce } from '@/lib/vue-helpers.js';
  export default {
    name: 'CollectionGridSize',
    mounted() {
      const collectionProducts = document.getElementById('fs-collection-products');
      const collectionGridSize = document.getElementById('collection-grid-size');

      if (collectionProducts) {
        this.gridLarge = collectionProducts.getAttribute('data-grid-large');
        this.gridSmall = collectionProducts.getAttribute('data-grid-small');
      }

      if (collectionGridSize) {
        this.grid_1 = collectionGridSize.getAttribute('data-swatch-grid-1');
        this.grid_1_over = collectionGridSize.getAttribute('data-swatch-grid-1-over');
        this.grid_2 = collectionGridSize.getAttribute('data-swatch-grid-2');
        this.grid_2_over = collectionGridSize.getAttribute('data-swatch-grid-2-over');
        this.grid_3 = collectionGridSize.getAttribute('data-swatch-grid-3');
        this.grid_3_over = collectionGridSize.getAttribute('data-swatch-grid-3-over');
        this.grid_4 = collectionGridSize.getAttribute('data-swatch-grid-4');
        this.grid_4_over = collectionGridSize.getAttribute('data-swatch-grid-4-over');
        this.grid_5 = collectionGridSize.getAttribute('data-swatch-grid-5');
        this.grid_5_over = collectionGridSize.getAttribute('data-swatch-grid-5-over');
      }

      const setLarge = VueCookies.get('gridViewLarge') ? JSON.parse(VueCookies.get('gridViewLarge')) : Number(this.gridLarge);
      const setSmall = VueCookies.get('gridViewSmall') ? JSON.parse(VueCookies.get('gridViewSmall')) : Number(this.gridSmall);

      this.setTheCurrentGridSizeLarge(setLarge);
      this.setTheCurrentGridSizeSmall(setSmall);

      this.resizeHandler = debounce(() => {
        this.isNarrowViewport = this.getIsNarrowViewport();
      }, 100, false);
      document.addEventListener('theme:resize:width', this.resizeHandler);
    },
    beforeUnmount() {
      if (this.resizeHandler) {
        document.removeEventListener('theme:resize:width', this.resizeHandler);
        if (this.resizeHandler.cancel) this.resizeHandler.cancel();
      }
    },
    data() {
      return {
        gridLarge: 0,
        gridSmall: 0,
        grid_1: '',
        grid_1_over: '',
        grid_2: '',
        grid_2_over: '',
        grid_3: '',
        grid_3_over: '',
        grid_4: '',
        grid_4_over: '',
        grid_5: '',
        grid_5_over: '',
        currentGridSizeSmall: '',
        currentGridSizeLarge: '',
        isNarrowViewport: window.innerWidth <= (window.theme?.sizes?.medium || 767),
        resizeHandler: null
      };
    },
    computed: {
      plpGlassEnabled() {
        if (window.theme && typeof window.theme.plpGlassEnabled === 'boolean') return window.theme.plpGlassEnabled;
        return false;
      }
    },
    methods: {
      // 1/2-column toggles only on mobile (theme Mobile Max Width); tablet + desktop get 3/4/5.
      getIsNarrowViewport() {
        return window.innerWidth <= (window.theme?.sizes?.medium || 767);
      },
      sendGridSizeUpdate(sizeLarge, sizeSmall) {
        emitter.emit('fs-update-grid-size-large', sizeLarge);
        emitter.emit('fs-update-grid-size-small', sizeSmall);
      },
      setTheCurrentGridSizeSmall(size) {
        this.currentGridSizeSmall = size;
        VueCookies.set('gridViewSmall', this.currentGridSizeSmall);
        this.setGridSize();
      },
      setTheCurrentGridSizeLarge(size) {
        this.currentGridSizeLarge = size;
        VueCookies.set('gridViewLarge', this.currentGridSizeLarge);
        this.setGridSize();
      },
      setGridSize() {
        const Grid = document.getElementById('fs-collection-products-grid');
        if (Grid) {
          Grid.setAttribute('data-grid-large', this.currentGridSizeLarge);
          Grid.setAttribute('data-grid-small', this.currentGridSizeSmall);
          window.dispatchEvent(new Event('resize'));
          this.sendGridSizeUpdate(this.currentGridSizeLarge, this.currentGridSizeSmall);
        }
      }
    }
  };
</script>

<template>
  <div class="grid-size-toggles" :class="{ 'is-narrow': isNarrowViewport }" style="display: flex">
    <button class="grid-size mobile grid-size--1" data-focus-element aria-label="1 product per row" @click.prevent="setTheCurrentGridSizeSmall(1)">
      <span v-if="plpGlassEnabled" class="grid-ico" :class="{ selected: currentGridSizeSmall === 1 }" :style="{ '--m': `url(${currentGridSizeSmall === 1 ? grid_1_over : grid_1})` }"></span>
      <img v-else :src="currentGridSizeSmall === 1 ? grid_1_over : grid_1" :class="currentGridSizeSmall === 1 ? 'selected' : ''" />
    </button>
    <button class="grid-size mobile grid-size--2" data-focus-element aria-label="2 products per row" @click.prevent="setTheCurrentGridSizeSmall(2)">
      <span v-if="plpGlassEnabled" class="grid-ico" :class="{ selected: currentGridSizeSmall === 2 }" :style="{ '--m': `url(${currentGridSizeSmall === 2 ? grid_2_over : grid_2})` }"></span>
      <img v-else :src="currentGridSizeSmall === 2 ? grid_2_over : grid_2" :class="currentGridSizeSmall === 2 ? 'selected' : ''" />
    </button>
    <button class="grid-size desktop grid-size--3" data-focus-element aria-label="3 products per row" @click.prevent="setTheCurrentGridSizeLarge(3)">
      <span v-if="plpGlassEnabled" class="grid-ico" :class="{ selected: currentGridSizeLarge === 3 }" :style="{ '--m': `url(${currentGridSizeLarge === 3 ? grid_3_over : grid_3})` }"></span>
      <img v-else :src="currentGridSizeLarge === 3 ? grid_3_over : grid_3" :class="currentGridSizeLarge === 3 ? 'selected' : ''" />
    </button>
    <button class="grid-size desktop grid-size--4" data-focus-element aria-label="4 products per row" @click.prevent="setTheCurrentGridSizeLarge(4)">
      <span v-if="plpGlassEnabled" class="grid-ico" :class="{ selected: currentGridSizeLarge === 4 }" :style="{ '--m': `url(${currentGridSizeLarge === 4 ? grid_4_over : grid_4})` }"></span>
      <img v-else :src="currentGridSizeLarge === 4 ? grid_4_over : grid_4" :class="currentGridSizeLarge === 4 ? 'selected' : ''" />
    </button>
    <button class="grid-size desktop grid-size--5" data-focus-element aria-label="5 products per row" @click.prevent="setTheCurrentGridSizeLarge(5)">
      <span v-if="plpGlassEnabled" class="grid-ico" :class="{ selected: currentGridSizeLarge === 5 }" :style="{ '--m': `url(${currentGridSizeLarge === 5 ? grid_5_over : grid_5})` }"></span>
      <img v-else :src="currentGridSizeLarge === 5 ? grid_5_over : grid_5" :class="currentGridSizeLarge === 5 ? 'selected' : ''" />
    </button>
  </div>
</template>

<style lang="scss">
  #collection-grid-size {
    .grid-size-toggles.is-narrow .grid-size {
      &.desktop {
        display: none;
      }

      &.mobile {
        display: block;
        padding-left: 0px;
        padding-right: 10px;
      }
    }

    .grid-size {
      cursor: pointer;

      &.desktop {
        display: block;
      }

      &.mobile {
        display: none;
      }

      .grid-ico {
        display: block;
        height: 16px;
        width: 16px;
        border: none;
        padding: 0;
        margin: 0;
        background-color: var(--plp-icon-inactive);
        -webkit-mask: var(--m) center / contain no-repeat;
        mask: var(--m) center / contain no-repeat;
      }

      .grid-ico.selected {
        background-color: var(--plp-icon-active);
      }

      /* Non-glass (A/B control / feature off) restores the original image + underline toggle. */
      img {
        padding-bottom: 3px;
        border-bottom: 1px solid #000;
        margin-bottom: -3px;

        &.selected {
          border-bottom: 1px solid #d1d1d1;
        }
      }

      &.grid-size--3 .grid-ico,
      &.grid-size--4 .grid-ico,
      &.grid-size--5 .grid-ico {
        width: 26px;
      }
    }
  }
</style>
